var render = function render(){var _vm=this,_c=_vm._self._c;return _c('orders-page',{attrs:{"title":"Today's Orders","show-date-filter":false,"include-completed-orders":false,"today-only":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }